__turbopack_context__.v({
  "active": "pagination-module-scss-module__QgmboG__active",
  "backToTop": "pagination-module-scss-module__QgmboG__backToTop",
  "current": "pagination-module-scss-module__QgmboG__current",
  "dots": "pagination-module-scss-module__QgmboG__dots",
  "nextPage": "pagination-module-scss-module__QgmboG__nextPage",
  "pageLink": "pagination-module-scss-module__QgmboG__pageLink",
  "pagination": "pagination-module-scss-module__QgmboG__pagination",
  "paginationWrapper": "pagination-module-scss-module__QgmboG__paginationWrapper",
  "prevPage": "pagination-module-scss-module__QgmboG__prevPage",
  "simplePagination": "pagination-module-scss-module__QgmboG__simplePagination",
});
